export default "skymp5-front/9f3fbf2db03e37e908b0c0659521be5d.jpg";